export default "__VITE_ASSET__DKkpYCAN__"